import 'jquery'
import 'slick-carousel-latest'

$('.recents-carousel').slick({
  dots: true,
  infinte: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
})
